const initialCallbotState = {
  classifiers: [],
}

export default initialCallbotState;
